import React, { useCallback, useState } from 'react';

import useStakedNoundles from '../hooks/useStakedNoundles';
import useNoundleStakingPool from '../hooks/useNoundleStakingPool';
import ThumbnailGrid from './ThumbnailGrid';

const StakedNoundlesPanel = () => {
  const tokens = useStakedNoundles();

  const stakingPool = useNoundleStakingPool();

  const [selection, setSelection] = useState({});
  const [staking, setStaking] = useState(false);

  const unstake = useCallback(
    async (unstakeAll) => {
      if (stakingPool) {
        try {
          if (unstakeAll) {
            await stakingPool.unstakeAll().then((tx) => {
              setStaking(true);
              return tx.wait();
            });
          } else {
            const selectedIndices = tokens
              .map((tokenId, index) => [tokenId, index])
              .filter(([tokenId, _]) => selection[tokenId])
              .map(([_, index]) => index);

            await stakingPool.batchUnstakeIndex(selectedIndices).then((tx) => {
              setStaking(true);
              return tx.wait();
            });
          }
        } catch (e) {
          if (e.code != 4001) {
            // 4001 means the user rejected the transaction in metamask
            console.log(e);
          }
        }
        setStaking(false);
      }
    },
    [tokens, selection, stakingPool]
  );

  const selectionCount = Object.values(selection).filter((s) => s).length;
  const unstakeAll = selectionCount === 0 || selectionCount === tokens.length;

  return (
    <div>
      <h2 className="mb-5">Staked Noundles ({tokens.length})</h2>
      <div className="py-3">
        <button
          onClick={() => unstake(unstakeAll)}
          disabled={staking || tokens.length === 0}
          className="btn btn-lg btn-primary text-white py-3 px-5"
        >
          {staking ? (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            ''
          )}
          Unstake {unstakeAll ? 'All' : selectionCount} tokens
        </button>
      </div>
      <ThumbnailGrid tokens={tokens} onSelectionChange={setSelection} />
    </div>
  );
};

export default StakedNoundlesPanel;
